import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="bg-gray rounded-lg shadow-lg p-6 mb-8">
        <h1 className="text-3xl font-bold mb-4">Welcome to F1 Predictions</h1>
        <p className="text-lg mb-6">
          After many years of sitting dormant, I have decided to reignite the competition
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-none p-6 rounded-lg how-it-works">
            <h2 className="text-xl font-bold mb-3">The Journey</h2>
            <ol className="list-none list-inside space-y-2">
              <li>The original version (last run in 2016) involved a lot of emails and spreadsheets</li>
              <li>Now, it will all (hopefully) be automated</li>
            </ol>
          </div>
          
          <div className="bg-none p-6 rounded-lg">
            <h2 className="text-xl font-bold mb-3">ROADMAP</h2>
            <ul className="list-none list-inside space-y-2">
              <li>Having only started rebuilding in March 2025, it may take a while to get the full functionality up and running</li>
              <li>Most importantly, submit your predictions as we can use them once the processing and leaderboards are fully active</li>
              <li>Next steps:</li>
              <li> - Improve the look and user experience</li>
              <li> - Troubleshoot any results retrieval and calculation issues</li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 text-center">
            <Link 
            to="/predictions" 
            className="bg-red-900 !text-white py-3 px-12 rounded-lg hover:bg-red-700 large-bold-link"
            >
            Enter My Predictions
            </Link>

          <ul className="space-y-4 list-none pl-5">
            
          </ul>
          <div className="bg-gray rounded-lg p-6 mt-8">
            <h2 className="text-2xl font-bold mb-4">Points Breakdown</h2>
            <p className="mb-4">Here's how each category is scored:</p>
           </div>
        </div>
        <div className="space-y-6">
            <div>
                <h3 className="font-bold text-lg mb-2">Podium Predictions</h3>
                <ul className="space-y-3 list-none pl-5">
                <li><strong>Pole (2 points):</strong> As listed on official results as finishing in 1st place in qualifying on the official classification results.</li>
                <li><strong>Winning Driver (6 points):</strong> As listed on official results as finishing in 1st place in the race.</li>
                <li><strong>Race 2nd (4 points):</strong> Predicting the driver who finishes the race in second place.</li>
                <li><strong>Race 3rd (2 points):</strong> Predicting the driver who finishes the race in third place.</li>
                </ul>
            </div>
            
            <div className="border-t pt-4">
                <h3 className="font-bold text-lg mb-2">Race Performance</h3>
                <ul className="space-y-3 list-none pl-5">
                <li><strong>Fastest Lap (1 point):</strong> Predicting the driver who sets the fastest lap time during the race.</li>
                <li><strong>First retirement/ last place (1 point):</strong> Predicting the driver who finishes in last place as listed on the official classification results.</li>
                </ul>
            </div>
            
            <div className="border-t pt-4">
                <h3 className="font-bold text-lg mb-2">Head-to-Head Competitions</h3>
                <ul className="space-y-3 list-none pl-5">
                <li><strong>Driver Head to Head (1 point):</strong> Which driver will finish higher - based on the official classification results listed on the official classification results. If the 2 drivers crash and take each other out, the winner is the one listed above the other in official results.</li>
                <li><strong>Team Head to Head (1 point):</strong> Which team will have the higher average finishing position (add both driver positions and divide by 2). E.g. If Team A finished 1st and 20th, and Team B finished 9th and 10th, Team B will win as their ave position was 9.5, Team A's ave was 10.5.</li>
                </ul>
            </div>
            
            <div className="border-t pt-4">
                <h3 className="font-bold text-lg mb-2">Bonus Points</h3>
                <ul className="space-y-3 list-none pl-5">
                <li><strong>Top 3 any order (2 bonus points):</strong> Predicting the three drivers who will finish in the top three positions, regardless of their exact finishing order.</li>
                <li><strong>Top 3 in order (6 bonus points):</strong> Predicting the exact finishing order of the top three drivers (1st, 2nd, and 3rd).</li>
                </ul>
            </div>
            </div>
      </div>
    </div>



  );
}



export default Home;